import { createSlice } from "@reduxjs/toolkit";

export const DEFAULT_ORDER_LIST_LAYOUT = "row_wise_details";
export const DEFAULT_SHOW_BARCODE = true;
export const REPORT_PRINT_HEADER_CBAHI = "cbahi";
export const REPORT_PRINT_HEADER_SUPER_GIT = "super_git";
export const DEFAULT_REPORT_PRINT_HEADER = REPORT_PRINT_HEADER_CBAHI;

export const toBoolean = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const settingsToMap = (settings) =>
  Object.fromEntries(
    (settings || []).map((setting) => [setting.key, setting.value]),
  );

const buildSettingsMap = (settings) =>
  Object.fromEntries((settings || []).map((item) => [item.key, item]));

const initialState = {
  raw: [],
  map: {},
  isLoading: false,
  error: null,
};

const SettingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      const rawSettings = action.payload || [];
      state.raw = rawSettings;
      state.map = buildSettingsMap(rawSettings);
    },
    updateSetting: (state, action) => {
      const updated = action.payload;
      if (!updated?.key) return;

      const exists = state.raw.some((item) => item.key === updated.key);
      state.raw = exists
        ? state.raw.map((item) =>
            item.key === updated.key ? { ...item, ...updated } : item,
          )
        : [...state.raw, updated];
      state.map = buildSettingsMap(state.raw);
    },
    setSettingsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSettingsError: (state, action) => {
      state.error = action.payload;
    },
    resetSettings: (state) => {
      state.raw = [];
      state.map = {};
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setSettings,
  updateSetting,
  setSettingsLoading,
  setSettingsError,
  resetSettings,
} = SettingsSlice.actions;

export const selectSettingValue = (state, key, fallback = "") =>
  state?.settings?.map?.[key]?.value ?? fallback;

export const selectSetting = (state, key) => state?.settings?.map?.[key];

export const selectShowBarcode = (state) => {
  const value = state?.settings?.map?.show_barcode?.value;
  return value === undefined || value === null
    ? DEFAULT_SHOW_BARCODE
    : toBoolean(value);
};

export const selectReportPrintHeader = (state) =>
  state?.settings?.map?.report_print_header?.value ||
  DEFAULT_REPORT_PRINT_HEADER;

export const selectIsSuperGitReportHeader = (state) =>
  selectReportPrintHeader(state) === REPORT_PRINT_HEADER_SUPER_GIT;

export const selectCurrentService = (state) => {
  const service = state?.auth?.user?.service;
  const serviceName = (service?.name || "").toLowerCase();
  if (serviceName)
    return serviceName.includes("radiology") ? "radiology" : "lab";
  if (service?.id === 2) return "radiology";
  if (service?.id === 1) return "lab";
  return state?.settings?.raw?.[0]?.service || null;
};

export const selectLogoSetting = (state, key) =>
  toBoolean(state?.settings?.map?.[key]?.value);

export const selectShowCbahiLogo = (state) =>
  selectLogoSetting(state, "is_cbahi_logo");

export const selectShowBusinessLogo = (state) =>
  selectLogoSetting(state, "is_standard_logo");

export default SettingsSlice.reducer;
